import React from 'react';

import { SubfolderBox } from '@qality/common-components/src/molecules/SubfolderBox';

import { useTestCaseRepositoryFoldersContext } from '../TestCaseRepositoryFoldersProvider';
import { TestCaseRepositoryIssuesProvider } from '../TestCaseRepositoryIssuesProvider';

export default function TestCaseRepositorySubfolders(): JSX.Element {
  const { currentFolder, getFolderById } =
    useTestCaseRepositoryFoldersContext();

  if (!currentFolder) {
    return null;
  }

  const subfolders = currentFolder.subfoldersIds.map((subfolderId) =>
    getFolderById(subfolderId)
  );

  return (
    <>
      {subfolders.map((subfolder) => (
        <TestCaseRepositoryIssuesProvider
          key={`subfolder-box-issue-provider-${subfolder.id}`}
          folder={subfolder}
          shouldFetchOnRender={false}
        >
          <SubfolderBox folder={subfolder} />
        </TestCaseRepositoryIssuesProvider>
      ))}
    </>
  );
}
